import { init } from '@atlaskit/insm';

import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import type { SessionDataType } from '@confluence/session-data/entry-points/SessionDataTypes';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

export function initializeINSM(_sessionData: SessionDataType): void {
	init({
		getAnalyticsWebClient: getAnalyticsWebClient(),
		experiences: {
			'edit-page': { enabled: true },
			'live-edit': { enabled: true },
		},
		population: StatsigConfigurations.getString('cc_ufo_group', 'unknown'),
	});
}
